import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { savePayorMap } from './group-payor-mapping-modal';

@Injectable({
  providedIn: 'root'
})
export class GroupPayorMappingService {

  constructor(private http:HttpClient,public errorService: ErrorService) { }

  SaveRecord(saveList: savePayorMap): Observable<any> {
    let url = "api/PayerService/SavePayerService";
    return this.http.post(url, saveList, { observe: 'response',responseType: "text"},).pipe(
        map(data => data.body),
        catchError(this.errorService.handleError)
    )
}



DeleteRecord(paramsData: URLSearchParams): Observable<any> {
  let url = "api/PayerService/DelPayerService?" ;
  return this.http.delete(url + paramsData, { observe: 'response' },).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}
getGroup(paramsData: URLSearchParams): Observable<any> {
  let url = "api/Lov/GetLovDropDown?";
  return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}  
getRender(paramsData: URLSearchParams): Observable<any> {
  let url = "api/Lov/GetLovDropDown?";
  return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}  
getPayer(paramsData: URLSearchParams): Observable<any> {
  let url = "api/Payerservice/GetPayerDropdown?";
  return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}


getService(): Observable<any> {
  let url = "api/Service/GetServiceDropdown?";
  return this.http.get<any>(url, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
}
getServiceDescription(paramsData: URLSearchParams): Observable<any> {
  let url = "api/Service/GetServiceDesc?";
  return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
    map(data => data.body),
    catchError(this.errorService.handleError)
  )
} 

   //==============================get employee permission==========================================//
   getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }



}

